const BATTERY_BODY_WIDTH_SVG = 14;
const BATTERY_LOW_THRESHOLD = 33;
const BATTERY_MID_THRESHOLD = 66;

export function getBatteryFillColor(batteryPct: number): string {
  if (batteryPct <= BATTERY_LOW_THRESHOLD) return 'var(--color-red)';
  if (batteryPct <= BATTERY_MID_THRESHOLD) return 'var(--color-yellow400)';
  return 'var(--color-green)';
}

export function getBatteryFillWidth(batteryPct: number): number {
  const level = batteryPct <= BATTERY_LOW_THRESHOLD ? 1 : batteryPct <= BATTERY_MID_THRESHOLD ? 2 : 3;
  const widths = [BATTERY_BODY_WIDTH_SVG / 3, (BATTERY_BODY_WIDTH_SVG / 3) * 1.5, BATTERY_BODY_WIDTH_SVG - 1.5];
  return widths[level - 1];
}
